module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.25.0@babel-runtime/core-js/get-iterator.js
// module id = 117
// module chunks = 1